import { Controller } from "stimulus"

export default class extends Controller {
  print(event) {
    const noImages = event.currentTarget.dataset.printNoImages === "true"
    
    if (noImages) {
      document.body.classList.add('print-no-images');
    } else {
      document.body.classList.remove('print-no-images');
    }
    
    window.print();
    
    setTimeout(() => {
      document.body.classList.remove('print-no-images');
    }, 500);
  }
}
